import authService from '../services/AuthService';
import { OpenAPI } from './generated';
import { OpenAPI as ArtifactsOpenAPI } from './artifacts/generated';

OpenAPI.BASE = '';
OpenAPI.TOKEN = async () => {
  const user = await authService.getUser();
  return user?.token ?? '';
};

ArtifactsOpenAPI.TOKEN = async () => {
  const user = await authService.getUser();
  return user?.token ?? '';
};
